{
  "loading": "Φόρτωση...",
  "placeholder": "Επιλέξτε…"
}
